import React from "react";
import styled from "styled-components";
import { media } from "../theme/breakpoints";
import StatsRow from "./StatsRow";
import QuickActions from "./QuickActions";
import TodaySchedule from "./TodaySchedule";
import RoomOccupancy from "./RoomOccupancy";
import { fmtINR } from "../utils/formatters";

const HomePage = ({ onOpenBooking, state }) => {
  const stats = state?.stats || {};

  const dashboardCards = [
    {
      label: "Bookings",
      value: stats.todayBookings?.roomsInUse || 0,
      subValue: `${stats.todayBookings?.roomsInUse || 0} of ${
        stats.todayBookings?.totalRooms || 0
      } rooms active`,
      color: "#00838c",
      icon: "ti-calendar",
    },
    {
      label: "Upcoming",
      value: stats.next7Days?.total || 0,
      subValue: "upcoming sessions",
      color: "#534AB7",
      icon: "ti-clock",
    },
    {
      label: "Revenue",
      value: fmtINR(stats.monthRevenue?.total || 0),
      subValue: `${stats.todayBookings?.total || 0} bookings`,
      color: "#00838c",
      icon: "ti-chart-bar",
    },
    {
      label: "Cancelled",
      value: stats.cancellations?.total || 0,
      subValue: "this period",
      color: "#d91b1b",
      icon: "ti-x",
    },
  ];

  return (
    <PageWrap>
      <StatsRow stats={dashboardCards} />
      <QuickActions />
      <SplitRow>
        {state?.todaySchedule?.length > 0 && (
          <TodaySchedule
            bookings={state?.todaySchedule}
            onOpenBooking={onOpenBooking}
          />
        )}
        <RoomOccupancy rooms={state?.roomOccupancy} />
      </SplitRow>
    </PageWrap>
  );
};

export default HomePage;

const PageWrap = styled.div`
  padding: 24px 16px;
  max-width: 1480px;
  margin: 0 auto;
  background: #f8fafc;
  min-height: 100vh;

  ${media.mobile} {
    padding: 28px 20px;
  }
  ${media.tablet} {
    padding: 40px 36px;
  }
  ${media.laptop} {
    padding: 48px 48px;
  }
`;

const SplitRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;

  ${media.laptop} {
    grid-template-columns: 2fr 1fr;
    gap: 28px;
  }
`;
